import { useTextes } from '@common/config';
import { OrganismeStatutEtapier } from '@common/services';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganismeDetailsContext } from '@common/contexts';
import { StepStatus } from '../types/enums/step-status.enum';
import { StepBloc } from './common/StepBloc';

export const Step1Info = () => {
  const t = useTextes('ParcoursOfa', 'EtapierStep1');
  const navigate = useNavigate();
  const { statutEtapier } = useOrganismeDetailsContext();

  return (
    <StepBloc status={(statutEtapier === OrganismeStatutEtapier.ETAPE_1) ? StepStatus.PROGRESS : StepStatus.DONE}
              title={t['ETAPE1_TEXTE1']}
              description={t['ETAPE1_TEXTE2']}
              buttons={[
                {
                  label: (statutEtapier === OrganismeStatutEtapier.ETAPE_1) ? 'Compléter mes informations' : 'Modifier',
                  onClick: () => navigate('/mon-ofa/edition/donnees-complementaires'),
                  priority: (statutEtapier === OrganismeStatutEtapier.ETAPE_1) ? 'primary' : 'secondary',
                },
              ]} />
  );
};
